import { gql } from '@apollo/client';
const PROFILE = gql `
  query Profile {
    readOnly
    me {
      id
      email
      username
      avatar
      maintenance
    }
  }
`;
export default PROFILE;
